import Cookie from 'sharedController/cookie';
import $ from 'jquery';
import SiteNavigation from 'frontendController/siteNavigation';

export default class CookiePolicy {
    init()
    {
        $(document).ready(this.ready());
    }

    ready()
    {
        this.setupSelectors();
        this.setupEvents();
    }

    setupSelectors()
    {
        this.acceptCookieWrap = $('#accept-cookie-policy-wrap');
        this.acceptCookieButton = $('#accept-cookie-policy-button');
        this.$notStickyContent = $('.site-header-wrapper').find('.not-sticky-content');
        this.$cookiePolicy = $('#cookie-policy');
        this.$acceptAllCookies = $('#accept-all-cookies');
        this.$learnMoreCookies = $('#learn-more-cookies');
    }

    setupEvents()
    {
        let me = this;
        let marginBuffer = $('#margin-buffer');
        let bufferHeight = SiteNavigation.calculateHeight() - me.acceptCookieWrap.outerHeight() + 'px';

        if (me.$cookiePolicy.length) {
            me.$cookiePolicy.foundation('open');
        }

        me.acceptCookieButton.on('click', function () {
            me.acceptCookies();
            marginBuffer.animate({height: bufferHeight }, 'fast');
        });

        me.$acceptAllCookies.on('click', function () {
            me.acceptCookies();
        });

        me.$learnMoreCookies.on('click', function (e) {
            e.preventDefault();
            Cookie.set('seenCookiePolicy', 1, 365, "/", null, null);
            window.location = $(this).attr('href');
        });
    }

    acceptCookies()
    {
        Cookie.set('acceptedCookiePolicy', 1, 365, "/", null, null);
        this.acceptCookieWrap.remove();
        this.$notStickyContent.css('margin-top', 0 + 'px');
        if (this.$cookiePolicy.length) {
            this.$cookiePolicy.foundation('close');
        }
    }
}